export default [
    {
        "id": "cart",
        "html": require('./cart/html').default
    }
]